import { render, staticRenderFns } from "./serverAuthorization.vue?vue&type=template&id=390ab884&scoped=true&"
import script from "./serverAuthorization.vue?vue&type=script&lang=js&"
export * from "./serverAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./serverAuthorization.vue?vue&type=style&index=0&id=390ab884&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390ab884",
  null
  
)

component.options.__file = "serverAuthorization.vue"
export default component.exports